import HeroSection from "./elements/HeroSection";
import OrdersSection from "./elements/OrdersSection";
import FeatureProducts from "./elements/FeatureProducts";
import ProductsSection from "./elements/ProductsSection";
import ServicesBanner from "../common/ServicesBanner";
import { orderGuidePagebannerData } from "../../lib/constants/ConstantsData";
import ColorSelection from "./elements/ColorSelection";
import { Navbar } from "@/components";
import PageWrapper from "@/components/PageWrapper";

const HomePage = () => {
  return (
    <main>
      <PageWrapper>
        <Navbar />
        <HeroSection />
      </PageWrapper>
      <OrdersSection />
      <FeatureProducts />
      <ColorSelection />
      <ProductsSection />
      <ServicesBanner home bannerData={orderGuidePagebannerData} />
    </main>
  );
};

export default HomePage;
